import { render, staticRenderFns } from "./ClientListHeaderItem.vue?vue&type=template&id=57c241ad&scoped=true&"
import script from "./ClientListHeaderItem.vue?vue&type=script&lang=js&"
export * from "./ClientListHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientListHeaderItem.vue?vue&type=style&index=0&id=57c241ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c241ad",
  null
  
)

export default component.exports